var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[(_vm.uiStore.viewCode === 1)?_c('editor-chat'):_vm._e(),(_vm.uiStore.viewCode === 2)?_c('editor-friend'):_vm._e(),(_vm.uiStore.viewCode === 3)?_c('editor-group'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }